import { render } from "./VCut.vue?vue&type=template&id=5c54d4f0"
import script from "./VCut.vue?vue&type=script&lang=js"
export * from "./VCut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b6b000019df918e5ba178116dc1dcf84/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__